<script setup>
import { ref, watch, computed, onMounted  } from 'vue';
import { useOrderStore } from '@/stores/OrderStore';
import { useAuthStore } from '@/stores/authStore';
import SkeletonPopup from '@/components/Popups/SkeletonPopup.vue';

const authStore = useAuthStore();
const orderStore = useOrderStore();

const openShift = 'Open Shift';
const closeShift = 'Close Shift';

async function handleOpenDrawer() {

    authStore.isSkeletonPopupVisible = true;

    await authStore.getOpeningEntryStatus();
    
    if (!authStore.openingEntryStatus) {
        authStore.isOpeningBalacePopupVisible = true;
        authStore.getTodayDate();
    } else {
        authStore.isClosingBalacePopupVisible = true;
    }
}

onMounted(() => {
    authStore.getOpeningEntryStatus();
});

</script>

<template>
    <div>
        <button @click="handleOpenDrawer" class="bg-white w-full text-center p-5 rounded-2xl flex gap-5 my-3">
            <span class=" cursor-pointer flex items-center gap-10">
                <i
                  class="pi text-purple-500 bg-purple-100 p-4 rounded-full"
                  :class="authStore.openingStatus === 'open' ? 'pi-lock-open' : 'pi-unlock'"
                  style="font-size: 1.875rem;"
                ></i>
                <span class="font-semibold">{{ authStore.openingStatus === 'open' ? closeShift : openShift }}</span>
            </span>
        </button>
        <SkeletonPopup v-if="authStore.isSkeletonPopupVisible"/>
    </div>
</template>

<style scoped>

</style>